var uiCopyToClipboard = {
	copy: "Copiar \"{value}\" al tablero",
	successMessage: "¡Copiado!",
	failureMessage: "¡No se puede copiar!"
};
var uiCopyToClipboardTranslationsEs = {
	uiCopyToClipboard: uiCopyToClipboard
};

export { uiCopyToClipboardTranslationsEs as default, uiCopyToClipboard };
